'use strict';

angular.module('shiftTraderApp')
  .controller('EmployeesCtrl', function ($scope, $modal, $location, flash, Users, $stateParams,
                                         org, users, positions, me) {
    $scope.me = me;
    $scope.org = org;
    $scope.departments = $scope.org.departments;
    $scope.users = users;
    $scope.positions = _.map(positions, function(pos) {
      if (_.isNull(pos.department_id)) {
        pos.department = {
          name: 'Uncategorized'
        };
      } else {
        var dept = _.find($scope.departments, {id: pos.department_id});
        if (!_.isUndefined(dept)) {
          pos.department = dept;
        }
      }
      return pos;
    });

    $scope.preselectedPositionId = _.has($stateParams, 'positionId') && !_.isNull($stateParams['positionId']) && !_.isUndefined($stateParams['positionId']) && $stateParams['positionId'];
    if ($scope.preselectedPositionId) {
      $scope.preselectedPositionId = parseInt($scope.preselectedPositionId);
    }

    $scope.showSelector = 'true';

    $scope.positions.unshift({id: -1, name: 'All Positions'});

    $scope.goToProfile = function(emp_id) {
      $location.path('profile/' + emp_id);
    };

    var calculateEmployeesToShow = function() {
      $scope.activeEmployees = _.where($scope.users, function(u) {
        return u.memberships[0].active === 1;
      });

      $scope.inactiveEmployees = _.where($scope.users, function(u) {
        return u.memberships[0].active === 0;
      });

      if ($scope.showSelector === 'true') {
        $scope.currentList = $scope.activeEmployees;
      } else {
        $scope.currentList = $scope.inactiveEmployees;
      }

      $scope.currentPositionIndex = -1;
      if ($scope.preselectedPositionId) {
        $scope.currentPositionIndex = $scope.preselectedPositionId;
      }

      $scope.usersByPosition = {};
      _.each($scope.positions, function(pos) {
        $scope.usersByPosition[pos.id] = [];
        $scope.usersByPosition[pos.id] = _.where($scope.currentList, function(usr) {
          return _.any(usr.users_positions, function(up) {
            return up.position.id === pos.id;
          });
        });
      });

      $scope.currentDataSet = $scope.currentList;
    };

    calculateEmployeesToShow();
    $scope.currentList = $scope.activeEmployees;

    $scope.$watch('currentPositionIndex', function(val) {
      if (_.isUndefined(val) || val === -1) {
        $scope.currentDataSet = $scope.currentList;
      } else {
        $scope.currentDataSet = $scope.usersByPosition[val];
      }
    });
  });
